import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
import { HttpClient, HttpEvent, HttpRequest, HttpHeaders } from '@angular/common/http';
import * as _ from 'underscore';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()

export class APIService {
  apiUrl = environment.apiUrl;
  logoUploadUrL = environment.logoUploadUrL;
  fileUploadUrL = environment.fileUploadUrL;

  logoimg = new BehaviorSubject('');

  value: any;
  offerTypeId: any;
  teamDetail: {
  };
  editGameList: {
  };
  gameStatementDetails: {
  };
  
  private data = new BehaviorSubject('default data');
  data$ = this.data.asObservable();

  changeData(data: string) {
    this.data.next(data)
    // console.log(this.data.next(data))
  }

  constructor(private localStorageService: LocalStorageService, private http: HttpClient) {
    this.gameStatementDetails = {};
    this.editGameList = {};
    this.teamDetail = {};
    this.offerTypeId;
    this.value;
  }

  doApiCall = function (callback, subpath, method, payload, customHeader, errorCallback?) {
    var self = this;

    self.baseUrl = self.apiUrl;

    self.url = (subpath) ? self.baseUrl + subpath : self.baseUrl;
    if (method) {
      self.method = method;
    }
    if (payload) {
      self.payload = payload;
    }

    if (localStorage.getItem('email') && localStorage.getItem('token')) {
      self.localStorageService.set('email', localStorage.getItem('email'));
      self.localStorageService.set('token', localStorage.getItem('token'));
      localStorage.removeItem('email')
      localStorage.removeItem('token')
    }

    var sessionData = self.localStorageService.get('token');
    var token = (sessionData) ? sessionData : "";
    var subString = subpath.split("?code")
    if (subpath === 'user/geturl' || subString[0] === 'user/auth') {
      token = '';
    } else if (!token) {
    } else {
      token = token;
    }
    // Set token
    // must clear header just incase prior headers are still there
    self.requestHeader = {};
    self.requestHeader['Access-Token'] = token;
    self.requestHeader['Content-Type'] = "application/json";
    //Set Custom header
    for (var key in customHeader) {
      self.requestHeader[key] = customHeader[key];
    }

    if (method && method == "POST") {
      this.http.post(
        // method: self.method,
        self.url,
        self.payload,
        // cache: false,
        // data: self.payload,
        { headers: self.requestHeader }
      ).subscribe(
        data => {
          if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else {
            callback(data, false);
          }
        },
        error => {
          if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else if (errorCallback) {
            errorCallback(error);
          }
        }
      )
    } else if (method && method == "PUT") {
      this.http.put(
        // method: self.method,
        self.url,
        self.payload,
        // cache: false,
        // data: self.payload,
        { headers: self.requestHeader }
      ).subscribe(
        data => {
          if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else {
            callback(data, false);
          }
        },
        error => {
          if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else if (errorCallback) {
            errorCallback(error);
          }
        }
      )
    } else if (method && method == "DELETE") {

      this.http.delete(
        self.url,
        // self.payload,
        { headers: self.requestHeader }
      ).subscribe(
        data => {
          if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else {
            callback(data, false);
          }
        },
        error => {
          if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else if (errorCallback) {
            errorCallback(error);
          }
        }
      )
    } else {
      this.http.get(
        // method: self.method,
        self.url,
        { headers: self.requestHeader }
        // cache: false,
        // data: self.payload,
        // headers: self.requestHeader
      ).subscribe(
        data => {
          if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else {
            callback(data, false);
          }
        },
        error => {
          if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
            this.localStorageService.remove('email');
            this.localStorageService.remove('token');
            // this.localStorageService.add('reloadPage', true);
            window.location.href = "/landing/signin";
          } else {
            console.error('API GET error for: ' + self.url, error);
            callback(null, true);
            if (errorCallback) {
              errorCallback(error);
            }
          }
        }
      )
    }

  }

  fileUpload = function (callback, subpath, method, payload, customHeader) {
    var self = this;
    self.baseUrl = self.apiUrl;;
    //self.baseUrl = "https://qaapi.statementgames.com/";
    // self.baseUrl = "http://10.80.6.103:8081/StatementGames/";
    //self.baseUrl = window.location.origin + ":8443/StatementGames/";

    self.url = (subpath) ? self.baseUrl + subpath : self.baseUrl;
    if (method) {
      self.method = method;
    }
    if (payload) {
      self.payload = payload;
    }
    var sessionData = this.localStorageService.get('token');
    var token = (sessionData) ? sessionData : "";
    var subString = subpath.split("?code")
    if (subpath === 'user/geturl' || subString[0] === 'user/auth') {
      token = '';
    } else if (!token) {
    } else {
      token = token;
    }
    // Set token
    // must clear header just incase prior headers are still there
    self.requestHeader = {};
    self.requestHeader['Access-Token'] = token;

    //Set Custom header
    for (var key in customHeader) {
      self.requestHeader[key] = customHeader[key];
    }

    self.fd = new FormData();

    if (payload && Object.keys(payload).length > 0) {
      _.map(Object.keys(payload), function (key) {
        let value = payload[key];
        self.fd.append(key, value);

      })
    }


    this.http.post(
      self.url,
      self.fd,
      { headers: self.requestHeader }
    ).subscribe(
      data => {
        if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
          this.localStorageService.remove('email');
          this.localStorageService.remove('token');
          window.location.href = "/landing/signin";
        } else {
          callback(data, false);
        }
      },
      error => {
        if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
          this.localStorageService.remove('email');
          this.localStorageService.remove('token');
          window.location.href = "/landing/signin";
        }
      }
    )
  }


  fileDownload = function (callback, subpath, method, payload, customHeader) {
    var self = this;
    self.url = (subpath) ? self.baseUrl + subpath : self.baseUrl;
    var sessionData = self.localStorageService.get('token');
    var token = (sessionData) ? sessionData : "";
    var moduleList = self.localStorageService.get('user');

    self.requestHeader = {};
    self.requestHeader['Access-Token'] = token;
    self.requestHeader['Content-Type'] = "application/json";

    self.http.get(
      self.url,
      {
        headers: self.requestHeader,
        responseType: 'arraybuffer'
      }
    ).subscribe(
      data => {
        if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
          this.localStorageService.remove('email');
          this.localStorageService.remove('token');
          window.location.href = "/landing/signin";
        } else {
          callback(data, false);
        }
      },
      error => {
        if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
          this.localStorageService.remove('email');
          this.localStorageService.remove('token');
          window.location.href = "/landing/signin";
        }
      }
    )
  }
 //file upload
 pushFileToStorage(file: File): Observable<HttpEvent<{}>> {
  let token1 = localStorage.getItem('token');

  const headerSettings: { [name: string]: string | string[]; } = {};
  headerSettings['Authorization'] = token1;

  const formdata: FormData = new FormData();
  formdata.append('file', file);
  formdata.append('email', localStorage.getItem('email'))

  const req = new HttpRequest('POST', this.apiUrl+'api/business/fileupload', formdata, {
    reportProgress: true,
    responseType: 'text',

  });

  const newHeader = new HttpHeaders(headerSettings);
  let changedRequest = req.clone({
    headers: newHeader
  });

  return this.http.request(changedRequest);
} 

logoUpload = function (callback, subpath, method, payload, customHeader) {
  var self = this;
  self.baseUrl = self.apiUrl;
  self.url = (subpath) ? self.baseUrl + subpath : self.baseUrl;
  if (method) {
    self.method = method;
  }
  if (payload) {
    self.payload = payload;
  }
  var sessionData = self.localStorageService.get('token');
  var token = (sessionData) ? sessionData : "";
  var subString = subpath.split("?code")
  if (subpath === 'user/geturl' || subString[0] === 'user/auth') {
    token = '';
  } else if (!token) {
  } else {
    token = token;
  }
  // Set token
  // must clear header just incase prior headers are still there
  self.requestHeader = {};
  self.requestHeader['Access-Token'] = token;

  //Set Custom header
  for (var key in customHeader) {
    self.requestHeader[key] = customHeader[key];
  }

  self.http.post(
    self.url,
    self.payload,
    { headers: self.requestHeader }
  ).subscribe(
    data => {
      if (data == 'Invalid Access Token or Expired' || data == "Access Token Not Found in the Request Header") {
        self.localStorageService.remove('email');
        self.localStorageService.remove('token');
        window.location.href = "/landing/signin";
      } else {
        callback(data, false);
      }
    },
    error => {
      if (error.error == 'Invalid Access Token or Expired' || error.error == "Access Token Not Found in the Request Header") {
        self.localStorageService.remove('email');
        self.localStorageService.remove('token');
        window.location.href = "/landing/signin";
      }
    }
  )
}
}
